exports = module.exports = global.IntlMessageFormat = require('intl-messageformat')


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/intl-messageformat-global.js
// module id = 616
// module chunks = 0